var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 199.4 155.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:none;}.cls-1{stroke:#fff;stroke-miterlimit:10;}.cls-2{fill:#33b8ce;}.cls-3{stroke:#33b8ce;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:1.6 1.6 1.6 1.6 1.6 1.6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.66,139s10.28-.27,16.67-2.66,13.57-5.86,14.54-12.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.94,37.56l1,1.19,0,0a.5.5,0,0,1-.07.7.5.5,0,0,1-.7-.08l-1-1.29a.5.5,0,0,1,.07-.7.5.5,0,0,1,.7.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3,39.88,4.12,41h0a.48.48,0,0,1,0,.69.49.49,0,0,1-.68,0L2.29,40.58A.49.49,0,1,1,3,39.87H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.31,42l1.22,1h0a.47.47,0,0,1,.07.67.47.47,0,0,1-.66.07l-1.26-1a.48.48,0,0,1-.07-.67A.47.47,0,0,1,5.29,42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.79,44l1.29.92h0a.46.46,0,0,1,.11.64.47.47,0,0,1-.65.11l-1.31-.92a.48.48,0,0,1-.11-.66A.46.46,0,0,1,7.78,44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.39,45.77l1.34.85h0a.45.45,0,1,1-.48.76l-1.37-.86a.46.46,0,0,1-.14-.63.46.46,0,0,1,.63-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.09,47.44l1.37.79h0a.44.44,0,0,1,.16.6A.45.45,0,0,1,14,49l-1.4-.8a.45.45,0,1,1,.45-.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.85,49l1.41.74h0a.43.43,0,0,1,.18.58.44.44,0,0,1-.58.19l-1.43-.74a.44.44,0,0,1-.18-.59.43.43,0,0,1,.58-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.68,50.45l1.43.69h0a.42.42,0,1,1-.36.76l-1.45-.68a.43.43,0,0,1-.2-.57.42.42,0,0,1,.56-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.56,51.8l1.46.64h0a.4.4,0,0,1,.21.53.42.42,0,0,1-.54.22l-1.47-.64A.42.42,0,0,1,21,52a.41.41,0,0,1,.54-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.48,53.06l1.48.6h0a.4.4,0,0,1-.3.74l-1.49-.59a.41.41,0,0,1-.22-.53.4.4,0,0,1,.52-.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.44,54.24l1.49.55h0a.38.38,0,0,1,.22.5.37.37,0,0,1-.49.22L27.16,55a.38.38,0,0,1-.23-.5.39.39,0,0,1,.5-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.43,55.33l1.51.52a.38.38,0,0,1,.23.48.37.37,0,0,1-.47.24l-1.52-.51a.39.39,0,0,1-.24-.49.38.38,0,0,1,.48-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.45,56.35l1.51.49a.36.36,0,0,1,.25.45.38.38,0,0,1-.46.25l-1.53-.48A.37.37,0,0,1,33,56.6a.38.38,0,0,1,.47-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36.49,57.3l1.53.45a.36.36,0,0,1-.2.69L36.28,58a.36.36,0,1,1,.2-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.55,58.19l1.54.42a.36.36,0,0,1,.25.42.37.37,0,0,1-.43.25l-1.55-.41a.36.36,0,0,1-.24-.43.34.34,0,0,1,.42-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.63,59l1.55.39a.35.35,0,0,1,.25.41.33.33,0,0,1-.41.24l-1.55-.38a.33.33,0,0,1-.25-.41.34.34,0,0,1,.41-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.73,59.78l1.55.36a.34.34,0,0,1,.25.39.33.33,0,0,1-.39.24l-1.56-.35a.33.33,0,0,1,.14-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.84,60.49l1.56.33a.32.32,0,0,1,.24.37.31.31,0,0,1-.37.24l-1.57-.32a.32.32,0,0,1,.13-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52,61.14l1.56.31a.31.31,0,0,1,.25.36.32.32,0,0,1-.36.24l-1.57-.3a.31.31,0,0,1,.11-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.09,61.75l1.57.28a.29.29,0,1,1-.1.58L55,62.33a.3.3,0,0,1-.25-.34.3.3,0,0,1,.35-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.24,62.31l1.57.26a.28.28,0,0,1,.24.32.3.3,0,0,1-.33.24l-1.58-.26a.28.28,0,0,1-.23-.33.27.27,0,0,1,.32-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.39,62.82l1.58.24a.28.28,0,0,1,.23.31.29.29,0,0,1-.31.23l-1.58-.23a.3.3,0,0,1-.24-.32.29.29,0,0,1,.32-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.55,63.29l1.58.22a.26.26,0,0,1-.07.51l-1.59-.2a.28.28,0,0,1-.23-.3.27.27,0,0,1,.3-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.71,63.72l1.58.2a.25.25,0,0,1-.05.49l-1.59-.19a.25.25,0,1,1,.06-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.88,64.11l1.59.18a.23.23,0,0,1,.21.26.24.24,0,0,1-.26.21l-1.59-.17a.24.24,0,0,1-.22-.27.23.23,0,0,1,.27-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.06,64.46l.84.08a.24.24,0,0,1,.21.26.24.24,0,0,1-.25.2L74,64.92a.23.23,0,0,1-.21-.25.23.23,0,0,1,.26-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.65 67.44 83.71 65.5 73.17 61.65 72.65 67.44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.32,108.88l.87-1.37a.49.49,0,0,1,.68-.15A.5.5,0,0,1,11,108l0,0-.83,1.32,0,0a.5.5,0,0,1-.85-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.11,106.19l1-1.29a.48.48,0,0,1,.78.57h0l-.93,1.28h0a.49.49,0,0,1-.79-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.07,103.63l1-1.24a.47.47,0,0,1,.73.6h0l-1,1.23h0a.49.49,0,0,1-.68.06.47.47,0,0,1-.06-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.15,101.18,16.23,100a.46.46,0,0,1,.68.61h0l-1.06,1.18h0a.47.47,0,0,1-.7-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.33,98.82l1.14-1.13a.44.44,0,0,1,.63,0,.46.46,0,0,1,0,.64h0L18,99.46h0a.45.45,0,0,1-.64,0,.46.46,0,0,1,0-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.63,96.57l1.18-1.09a.44.44,0,0,1,.62,0,.43.43,0,0,1,0,.61h0l-1.16,1.08h0a.44.44,0,0,1-.63,0,.46.46,0,0,1,0-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,94.42l1.23-1a.43.43,0,1,1,.55.65h0l-1.21,1h0a.43.43,0,0,1-.56-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.49,92.38l1.28-1a.41.41,0,0,1,.58.07.42.42,0,0,1-.07.58h0L25,93h0a.42.42,0,0,1-.59-.07.43.43,0,0,1,.07-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.06,90.45l1.32-.93a.4.4,0,1,1,.46.66h0l-1.3.92h0a.41.41,0,1,1-.47-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.71,88.63l1.36-.86a.39.39,0,0,1,.54.12.4.4,0,0,1-.12.54h0l-1.33.86h0a.39.39,0,0,1-.55-.12.4.4,0,0,1,.12-.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.44,86.94l1.39-.81a.38.38,0,1,1,.38.66h0l-1.37.8h0a.38.38,0,0,1-.53-.14.37.37,0,0,1,.14-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.24,85.36l1.43-.73a.35.35,0,0,1,.49.15.37.37,0,0,1-.15.5h0L35.59,86h0a.39.39,0,0,1-.51-.16.36.36,0,0,1,.16-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.11,83.92l1.46-.67a.34.34,0,0,1,.47.17.35.35,0,0,1-.17.47h0l-1.44.67h0a.36.36,0,1,1-.31-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41,82.61,42.53,82a.35.35,0,0,1,.26.64h0l-1.47.61h0a.35.35,0,0,1-.46-.19.35.35,0,0,1,.19-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,81.43l1.51-.54a.34.34,0,0,1,.23.63h0l-1.49.55h0a.35.35,0,0,1-.44-.21.34.34,0,0,1,.21-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.07,80.39l1.53-.47a.32.32,0,1,1,.19.61h0L47.27,81h0a.32.32,0,1,1-.19-.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.15,79.48l1.55-.4a.32.32,0,0,1,.38.22.31.31,0,0,1-.22.38h0l-1.54.4h0a.32.32,0,0,1-.39-.23.31.31,0,0,1,.22-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.26,78.71l1.57-.33a.3.3,0,0,1,.35.23A.29.29,0,0,1,55,79h0l-1.56.34h0a.31.31,0,0,1-.37-.23.3.3,0,0,1,.24-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.4,78.08,58,77.82a.29.29,0,1,1,.09.57h0l-1.57.27h0a.29.29,0,0,1-.34-.23.31.31,0,0,1,.24-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.57,77.59l1.6-.2a.28.28,0,0,1,.31.24.29.29,0,0,1-.24.31h0l-1.58.21h0a.28.28,0,1,1-.08-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.76,77.23l1.6-.14a.27.27,0,0,1,.29.25.27.27,0,0,1-.24.28h0l-1.58.15h0a.27.27,0,0,1-.29-.25.26.26,0,0,1,.24-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66,77l1.61-.06a.24.24,0,0,1,.26.24.25.25,0,0,1-.24.26l-1.6.08h0a.25.25,0,0,1-.27-.24A.26.26,0,0,1,66,77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.17,76.89h1.6a.25.25,0,0,1,0,.49l-1.59,0a.26.26,0,0,1-.26-.24.25.25,0,0,1,.24-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.37,76.91,74,77a.24.24,0,0,1,.23.24.24.24,0,0,1-.25.22l-1.59,0a.23.23,0,0,1-.23-.24.23.23,0,0,1,.24-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.57,77l1.6.12a.22.22,0,1,1,0,.43l-1.59-.1a.22.22,0,0,1-.22-.23.23.23,0,0,1,.24-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.77,77.29l1.59.17a.21.21,0,1,1,0,.41l-1.59-.15a.21.21,0,0,1-.2-.23.22.22,0,0,1,.23-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82,77.65l1.59.22a.21.21,0,0,1,.17.22.2.2,0,0,1-.23.17l-1.58-.2a.21.21,0,0,1,0-.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "81.04 80.63 92.22 79.69 82.07 74.91 81.04 80.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M42.19,6.63l.37,1.52v0a.49.49,0,0,1-1,.24l-.4-1.58a.49.49,0,1,1,1-.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43,9.67l.49,1.5v0a.48.48,0,0,1-.91.29L42.07,10A.49.49,0,0,1,43,9.65h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44,12.67l.56,1.48h0a.47.47,0,0,1-.87.34L43.12,13a.48.48,0,0,1,.89-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.17,15.62l.63,1.46h0a.45.45,0,0,1-.23.6.47.47,0,0,1-.6-.24L44.32,16a.47.47,0,0,1,.24-.61.46.46,0,0,1,.6.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.46,18.52,47.15,20h0a.45.45,0,0,1-.21.59.45.45,0,0,1-.59-.2l-.71-1.44a.45.45,0,1,1,.8-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.88,21.36l.75,1.4h0a.42.42,0,0,1-.17.58.44.44,0,0,1-.58-.17l-.77-1.41a.43.43,0,0,1,.76-.42h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M49.42,24.14l.81,1.36h0a.41.41,0,0,1-.14.57.42.42,0,0,1-.57-.14l-.83-1.37a.42.42,0,0,1,.72-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.07,26.85,52,28.17h0a.4.4,0,0,1-.11.56.41.41,0,0,1-.56-.11l-.89-1.34a.39.39,0,0,1,.11-.56.41.41,0,0,1,.57.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52.85,29.48l.94,1.29h0a.38.38,0,0,1-.08.54.4.4,0,0,1-.55-.08l-.95-1.29a.4.4,0,0,1,.64-.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.75,32l1,1.24h0a.38.38,0,0,1-.59.47l-1-1.25a.38.38,0,1,1,.59-.48h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.76,34.49l1.05,1.2h0a.38.38,0,0,1,0,.52.36.36,0,0,1-.51,0L56.2,35a.37.37,0,1,1,.55-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.89,36.86,60,38h0a.35.35,0,1,1-.5.48l-1.12-1.14a.36.36,0,0,1,.51-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.12,39.12l1.15,1.09h0a.34.34,0,0,1-.46.5l-1.18-1.1a.34.34,0,1,1,.47-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.45,41.27l1.21,1h0a.33.33,0,0,1,0,.46.32.32,0,0,1-.45,0l-1.23-1a.33.33,0,0,1,0-.47.35.35,0,0,1,.47,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.89,43.31l1.26,1h0a.32.32,0,0,1,0,.44.3.3,0,0,1-.43.05l-1.28-1a.33.33,0,0,1-.06-.45.34.34,0,0,1,.45-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.43,45.23l1.3.92h0a.3.3,0,0,1-.34.49l-1.32-.92a.3.3,0,1,1,.34-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M71.06,47l1.35.85h0a.28.28,0,0,1-.3.48l-1.36-.84a.29.29,0,1,1,.3-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M73.77,48.7l1.39.78h0a.25.25,0,0,1,.1.36.27.27,0,0,1-.36.11l-1.41-.78a.28.28,0,0,1,.27-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.56,50.24,78,51h0a.25.25,0,0,1,.12.34.27.27,0,0,1-.35.12l-1.43-.72a.26.26,0,0,1-.12-.35.27.27,0,0,1,.35-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M79.41,51.64l1.46.65h0a.25.25,0,0,1,.12.33.23.23,0,0,1-.32.12l-1.46-.64a.26.26,0,0,1-.13-.34.25.25,0,0,1,.33-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.33,52.91l1.48.59h0a.23.23,0,1,1-.17.43l-1.5-.58a.22.22,0,0,1-.13-.3.23.23,0,0,1,.31-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.31,54.06l1.51.52a.23.23,0,0,1,.14.27.22.22,0,0,1-.28.14l-1.52-.51A.22.22,0,0,1,85,54.2a.23.23,0,0,1,.28-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.33,55.07l1.17.35a.21.21,0,0,1-.12.4l-1.17-.35a.2.2,0,0,1-.14-.26.21.21,0,0,1,.26-.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.85 57.92 98.07 57.61 88.2 52.27 86.85 57.92"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 163.12,
    cy: 54.18,
    rx: 4.9,
    ry: 3.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.41,52.81c-2.47,0-4.65-1.09-6.12-1.54a6,6,0,0,0-2.29-.36,3.55,3.55,0,0,0,0,7.1,6.25,6.25,0,0,0,2.64-.6,22.55,22.55,0,0,1,6-1.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M167.84,52.81c2.47,0,4.66-1.09,6.12-1.54a6.09,6.09,0,0,1,2.3-.36,3.55,3.55,0,0,1,0,7.1,6.35,6.35,0,0,1-2.65-.6,22.55,22.55,0,0,0-6-1.49"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 160.46,
    y1: 57.12,
    x2: 160.46,
    y2: 62.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 165.84,
    y1: 57.12,
    x2: 165.84,
    y2: 62.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.41,88.29s.15-3-.27-3.72-1.64-.75-1.64-.75H145.66a30.64,30.64,0,0,1-4.09,12.38c-7.72,12.85-12.64,17-14.41,25.18-2,9.11.18,19.33,3.37,34.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.52,155.33c2.66-14.89-.35-14.89-2.57-15.34a60.2,60.2,0,0,0-11-1.24c-4.79,0-7.63-1.51-9.58-4.26s-.89-7-.53-8.33,1.06-2.22.26-3.37-2.75-3.46-2.75-4.26,1.51-1.5,1.51-1.5a7.45,7.45,0,0,1-2.21-1.87c-.63-1,.1-3.15.62-4.87s-.69-2.42-3.44-3.28-4.37-2-4.31-4.3c0-1.55,1.07-3.76,3.13-6.35s8.16-11,8.16-13.12a74.94,74.94,0,0,1-.88-9.76c0-4.25,1.06-19,14.1-28.28s35.2-12.86,53.65-5.41,22.7,24.74,23.23,26.69a54.55,54.55,0,0,1,1.32,5.68h8.52c2.13,0,2.76-.14,3.33-.6a1.53,1.53,0,0,0,.55-1.14v-8h10.64v8h0a1.55,1.55,0,0,0,.55,1.13c.57.46,1.21.61,3.34.61h3.6a11.7,11.7,0,0,1,11.71,11.7v4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 173.61,
    y: 88.03,
    width: 16.41,
    height: 5.23,
    rx: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M186.93,95.12v27.94s-1.06,23.27,12,31.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M176.89,95.12v27.94s1.06,23.27-12,31.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.28,95.12V143s-.53,10.64-8,10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.47,95.12V146.2s.8,7.72,5.85,7.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.65.48l.06,1.63a.48.48,0,0,1-.47.51.5.5,0,0,1-.51-.46v0L131.65.57v0a.5.5,0,1,1,1-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.71,3.72l0,1.61a.49.49,0,0,1-.49.46.47.47,0,0,1-.45-.48v0l0-1.58h0a.48.48,0,0,1,.49-.47.47.47,0,0,1,.47.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.58,6.93l-.12,1.61a.46.46,0,0,1-.91-.07h0l.1-1.58h0a.46.46,0,0,1,.49-.43.45.45,0,0,1,.43.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M132.3,10.13l-.19,1.6a.44.44,0,0,1-.49.37.42.42,0,0,1-.37-.47h0l.17-1.58h0a.44.44,0,0,1,.49-.39.45.45,0,0,1,.39.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.88,13.32l-.25,1.58a.41.41,0,0,1-.82-.12h0l.23-1.57h0a.43.43,0,0,1,.48-.36.42.42,0,0,1,.35.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131.35,16.48,131,18.06a.39.39,0,1,1-.77-.15h0l.29-1.56h0a.4.4,0,1,1,.79.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.7,19.62l-.36,1.56a.37.37,0,0,1-.73-.16h0l.34-1.55h0a.4.4,0,0,1,.46-.29.38.38,0,0,1,.29.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130,22.74l-.42,1.55a.35.35,0,1,1-.68-.18h0l.39-1.54h0a.37.37,0,1,1,.71.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.09,25.83l-.47,1.54a.34.34,0,0,1-.42.22.33.33,0,0,1-.22-.41h0l.45-1.53h0a.34.34,0,0,1,.66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M128.13,28.89l-.51,1.52a.33.33,0,0,1-.4.2.32.32,0,0,1-.2-.4l.49-1.52h0a.33.33,0,1,1,.62.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.08,31.92l-.57,1.5a.29.29,0,0,1-.38.17.3.3,0,0,1-.17-.38l.54-1.5a.31.31,0,0,1,.39-.19.3.3,0,0,1,.19.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M125.93,34.91l-.61,1.48a.28.28,0,0,1-.36.15.27.27,0,0,1-.15-.36l.59-1.48a.28.28,0,1,1,.53.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.69,37.87,124,39.33a.26.26,0,1,1-.47-.21l.63-1.46a.26.26,0,0,1,.35-.15.27.27,0,0,1,.14.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.36,40.78l-.69,1.45a.24.24,0,1,1-.43-.21l.67-1.44a.26.26,0,0,1,.33-.13.25.25,0,0,1,.12.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122,43.66l-.74,1.42a.2.2,0,0,1-.29.09.21.21,0,0,1-.09-.29l.71-1.43a.23.23,0,0,1,.31-.1.22.22,0,0,1,.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.46,46.49l-.78,1.4a.2.2,0,0,1-.27.08.2.2,0,0,1-.08-.27l.76-1.41a.21.21,0,0,1,.28-.09.21.21,0,0,1,.09.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.88,49.28l-.82,1.38a.18.18,0,0,1-.24.06.19.19,0,0,1-.07-.25l.8-1.38a.19.19,0,0,1,.26-.07.18.18,0,0,1,.07.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M117.23,52l-.86,1.36a.17.17,0,0,1-.22,0,.17.17,0,0,1-.05-.22l.84-1.36a.17.17,0,0,1,.29.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.69 50.28 111.02 60.89 119.5 53.54 114.69 50.28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.16247ae9393791064e137067826a2b18.svg";
export { ForwardRef as ReactComponent };